import { bindable, customAttribute, inject } from 'aurelia-framework';
import $ from 'jquery';
import * as moment from 'moment';
import 'moment-timezone';

@customAttribute('datepicker')
@inject(Element)
export class DatePicker {
	@bindable displayMode: any;
	@bindable min: any;
	@bindable max: any;
	@bindable businessTimezone: any;
	// --0: normal; 1: 15th; 2: lastDayOfMonth
	element: any;
	datesEnabled: any;

	constructor(element) {
		this.element = element;
	}

	/// WCAG Compliance
	configureAccessibility() {

		const datePickers = document.querySelectorAll('.datepicker');

		// for label dates
		const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
		const offsetFromUTC = (new Date()).getTimezoneOffset() * 360_000; // getTimezoneOffset() returns minutes

		datePickers.forEach(dp => {
			// set roles
			dp.querySelectorAll('th,td')
				.forEach(elem => {
					elem.setAttribute('role', 'button');
				});

			// set all dates for all open datepickers
			dp.querySelectorAll('[class$="day"]')
				.forEach(elem => {
					let date = new Date(+elem.getAttribute('data-date') + offsetFromUTC);
					let dateStr = date.toLocaleDateString('US-en', dateOptions);
					elem.setAttribute('aria-label', dateStr);
				});

			// Set aria-disabled attributes
			dp.querySelectorAll('[class*="disabled"]')
				.forEach(elem => {
					elem.setAttribute('aria-disabled', 'true');
				});
		});
	}

	attached() {
		this.datesEnabled = [];
		$(this.element).datepicker(this.configureOption())
			.on('change', e => fireEvent(e.target, 'input'))
			.on('click show change', this.configureAccessibility);

		// This is a workaround for mobile devices, when using the "next" button to tab through a form
		// the keydown event never gets fired and the bootstrap datepicker only hides the popup picker
		// on keydown for tab. This forces a tab keydown event on blur so the calendar always goes away
		this.element.onblur = (e) => {
			if (e.relatedTarget !== null) {
				this.element.dispatchEvent(new KeyboardEvent('keydown', { keyCode: 9 } as KeyboardEventInit));
			}
		};
	}

	detached() {
		$(this.element)
			.datepicker('destroy')
			.off('change');
	}

	displayModeChanged(newValue, oldValue) {
		this.detached();
		$(this.element).datepicker(this.configureOption())
			.on('change', e => fireEvent(e.target, 'input'));
	}

	maxChanged(newValue, oldValue) {
		this.detached();
		$(this.element).datepicker(this.configureOption())
			.on('change', e => fireEvent(e.target, 'input'));
	}

	businessTimezoneChanged(newValue, oldValue) {
		this.detached();
		$(this.element).datepicker(this.configureOption())
			.on('change', e => fireEvent(e.target, 'input'));
	}

	configureOption() {
		let min: number = 0;
		if (this.min !== undefined) {
			min = this.min;
		}

		let max: number = 3650;
		if (this.max !== undefined) {
			max = this.max;
		}

		let startDate = moment(this.businessTimezone ? moment.tz(this.businessTimezone).format('MM/DD/YYYY') : new Date()).add(min, 'days').toDate();
		let endDate = moment(this.businessTimezone ? moment.tz(this.businessTimezone).format('MM/DD/YYYY') : new Date()).add(max, 'days').toDate();
		let func = this.displayMode === 2 ? function (date) {
			let month = date.getMonth();
			date.setDate(date.getDate() + 1);
			if (date.getMonth() !== month) {
				return true;
			}
			return false;
		} : this.displayMode === 1 ? function(date) {
			if (date.getDate() === 15) {
				return true;
			}
			return false;
		} : function(date) {
			return true;
		};

		let options = {
			showOn: 'button',
			showButtonPanel: true,
			buttonImageOnly: false,
			buttonText: 'Calendar View',
			closeText: 'Close',
			startDate,
			endDate,
			orientation: 'auto auto',
			format: 'mm/dd/yyyy',
			beforeShowDay: func,
			autoclose: true
		};
		return options;
	}
}

function createEvent(name) {
	let event = document.createEvent('Event');
	event.initEvent(name, true, true);
	return event;
}

function fireEvent(element, name) {
	let event = createEvent(name);
	element.dispatchEvent(event);
}
